export const Skeleton = ({ className = '' }) => (
  <div className={`skeleton ${className}`} aria-hidden="true" />
);

export const MetricsSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="metrics-skeleton">
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="metric">
        <Skeleton className="h-2.5 w-20" />
        <Skeleton className="h-7 w-24 mt-3" />
      </div>
    ))}
  </div>
);

export const TableSkeleton = ({ rows = 8, cols = 5 }) => (
  <div className="table-container" data-testid="table-skeleton">
    <table className="table-modern">
      <thead>
        <tr>
          {Array.from({ length: cols }, (_, i) => (
            <th key={i}><Skeleton className="h-2.5 w-16" /></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }, (_, r) => (
          <tr key={r}>
            {Array.from({ length: cols }, (_, c) => (
              <td key={c}>
                <Skeleton className={c === 0 ? 'h-3 w-4/5' : c === cols - 1 ? 'h-3 w-10 ml-auto' : 'h-3 w-3/5'} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const ListSkeleton = ({ rows = 6 }) => (
  <div className="divide-y divide-slate-100" data-testid="list-skeleton">
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="flex items-center gap-3 p-3">
        <Skeleton className="h-9 w-9 rounded-lg" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-3 w-2/5" />
          <Skeleton className="h-2.5 w-1/5" />
        </div>
        <Skeleton className="h-4 w-12" />
      </div>
    ))}
  </div>
);

export const PageSkeleton = () => (
  <div className="space-y-5 animate-fade-in" data-testid="page-skeleton">
    <div className="flex items-center justify-between gap-4">
      <div className="space-y-2">
        <Skeleton className="h-6 w-56" />
        <Skeleton className="h-3 w-72" />
      </div>
      <Skeleton className="h-9 w-28" />
    </div>
    <MetricsSkeleton />
    <TableSkeleton />
  </div>
);
